// extracted by mini-css-extract-plugin
export default {"section":"Progress_section__tJGaL","tabs":"Progress_tabs__gh96b","tab":"Progress_tab__eGk+C","active":"Progress_active__aHIpM"};